import React, { useState } from 'react';
import { Box, Typography, List, ListItemButton, ListItemText, ListItemIcon, Divider, Dialog, DialogTitle, DialogContent, IconButton, TextField, InputAdornment } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import TableCard from './TableCard';

function getTableSummary(table, participants) {
  const seatCount = table.seat_count;
  const filled = (table.seats || []).filter(s => s.participant_id).length;
  const empty = seatCount - filled;
  let typeLabel = 'Yuvarlak masa';
  if (table.type === 'dikdortgen') typeLabel = 'Dikdörtgen masa';
  if (table.type === 'kare') typeLabel = 'Kare masa';
  return `${typeLabel}, ${seatCount} koltuk, ${empty === 0 ? 'Hepsi dolu' : `${empty} boş`}`;
}

const MasalarTab = ({ tables, participants, onTableEdit }) => {
  const [selectedTable, setSelectedTable] = useState(null);
  const [search, setSearch] = useState('');
  const sortedTables = [...tables]
    .filter(t =>
      !search ||
      (t.name && t.name.toLocaleLowerCase('tr').includes(search.toLocaleLowerCase('tr')))
    )
    .sort((a, b) => (a.order_no || 0) - (b.order_no || 0));

  return (
    <Box>
      <TextField
        size="small"
        placeholder="Masa ara..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          )
        }}
      />
      <List>
        {sortedTables.map((table, idx) => (
          <React.Fragment key={table.id}>
            <ListItemButton onClick={() => setSelectedTable(table)}>
              <ListItemIcon>
                <Typography variant="h6">{table.order_no || idx + 1}.</Typography>
              </ListItemIcon>
              <ListItemText
                primary={<Typography fontWeight={700}>{table.name}</Typography>}
                secondary={getTableSummary(table, participants)}
              />
              <ChevronRightIcon sx={{ color: 'grey.400', ml: 1, alignSelf: 'center' }} />
            </ListItemButton>
            <Divider />
          </React.Fragment>
        ))}
      </List>
      <Dialog open={!!selectedTable} onClose={() => setSelectedTable(null)} maxWidth="sm" fullWidth>
        {selectedTable && (
          <>
            <DialogTitle>
              Masa bilgileri
              <IconButton onClick={() => setSelectedTable(null)} sx={{ position: 'absolute', right: 8, top: 8 }}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Typography variant="h6" fontWeight={700}>{selectedTable.name}</Typography>
              <Typography variant="body2" color="text.secondary" mb={2}>
                {getTableSummary(selectedTable, participants)}
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                <TableCard table={selectedTable} getParticipant={id => participants.find(p => p.id === id)} scale={0.9} />
              </Box>
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle1" fontWeight={600} mb={1}>Koltuklar</Typography>
              <List>
                {(selectedTable.seats || []).map((seat, i) => {
                  const participant = participants.find(p => p.id === seat.participant_id);
                  return (
                    <ListItemButton key={seat.id}>
                      <ListItemText
                        primary={<>{i + 1}. {participant ? participant.name : <em>Boş</em>}</>}
                        secondary={participant ? selectedTable.name : ''}
                      />
                    </ListItemButton>
                  );
                })}
              </List>
            </DialogContent>
          </>
        )}
      </Dialog>
    </Box>
  );
};

export default MasalarTab; 